/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const CourseSetupDetailsForm: FC = () => {
  const { t } = useTranslation()
  
  const setupOptions = [
    {key: 'course_description', label: t('setup-course-main.course-description')},
    {key: 'course_assessment', label: t('setup-course-main.course-assessment-and-measurement')},
    {key: 'course_materials', label: t('setup-course-main.course-materials')},
    {key: 'course_technologies', label: t('setup-course-main.course-technologies')},
    {key: 'course_instructions', label: t('setup-course-main.course-instructions-activities')},
    {key: 'course_outline', label: t('setup-course-main.course-outline')},
    {key: 'course_learner_support', label: t('setup-course-main.learner-support')},
    {key: 'course_plagiarism', label: t('setup-course-main.plagiraism-academic-integrity')},
    {key: 'course_grading_plan', label: t('setup-course-main.grading-plan')},
    {key: 'course_performance_expectations', label: t('setup-course-main.performance-expectation')},
  ]

  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()

  const serverValues = {
    options:
      setupData ? setupOptions.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      }) : []
  }


  return (

    <>{serverValues &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>
          <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline'>
            {values["options"].map((option,index) => 
              <Grid item xs={12} md={4} key={index}>
                <CheckboxField 
                  isSwitch={true}
                  hasLine={true}
                  index={index}
                  valueSelector='is_enabled'
                  fieldProps={{
                    label: option.label,
                    name: `options[${index}]`
                  }} 
                  onChange={(value)=> {
                    if(value.is_enabled)enableOption(option.key)
                    else disableOption(option.key)
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      }
    </Formik>
    }</>
  )
}
export default CourseSetupDetailsForm

